import axios from '@/axios.js'

export default {
    listIntegrationTypes: async () => {
        const response = await axios.adminapi.get('v4/resorts/integration-types')
        return response.data.object
    },
    listIntegrations: async (resortUuid) => {
        const response = await axios.adminapi.get(`v4/resorts/${resortUuid}/integrations`)
        return response.data.object.data
    },
    createIntegration: async (resortUuid, integrationUuid, payload) => {
        const response = await axios.adminapi.post(`v4/resorts/${resortUuid}/integrations/${integrationUuid}`, payload)
        return response.data.object
    },
    updateIntegration: async (resortUuid, integrationUuid, payload) => {
        const response = await axios.adminapi.patch(`v4/resorts/${resortUuid}/integrations/${integrationUuid}`, payload)
        return response.data.object
    },
    deleteIntegration: async (resortUuid, integrationUuid) => {
        await axios.adminapi.delete(`v4/resorts/${resortUuid}/integrations/${integrationUuid}`)
    }
}
